import { company } from "./company"

export const contactContent = {
  title: { nl: "Laten we praten", en: "Let's talk" },
  subtitle: {
    nl: "Heb je een project in gedachten? We horen graag van je.",
    en: "Have a project in mind? We'd love to hear from you.",
  },
  description: {
    nl: "Of je nu iets nieuws wilt bouwen, bestaande systemen wilt optimaliseren, of gewoon de mogelijkheden wilt verkennen, neem contact op en laten we in gesprek gaan.",
    en: "Whether you're looking to build something new, optimise existing systems, or just want to explore possibilities, reach out and let's start a conversation.",
  },
  info: {
    title: { nl: "Neem contact op", en: "Get in touch" },
    email: { nl: "Stuur ons een e-mail", en: "Email us" },
    phone: { nl: "Bel ons", en: "Call us" },
    social: { nl: "Verbind op social media", en: "Connect on social media" },
    location: { nl: "Werkgebied", en: "Where we work" },
    responseTime: {
      nl: "We reageren doorgaans binnen 24 uur",
      en: "We typically respond within 24 hours",
    },
  },
  form: {
    title: { nl: "Stuur ons een bericht", en: "Send us a message" },
    name: { nl: "Je naam", en: "Your name" },
    namePlaceholder: { nl: "Jan Jansen", en: "John Doe" },
    email: { nl: "Je e-mailadres", en: "Your email" },
    emailPlaceholder: { nl: "jan@voorbeeld.nl", en: "john@example.com" },
    phone: { nl: "Telefoonnummer (optioneel)", en: "Phone number (optional)" },
    phonePlaceholder: { nl: "+31 6 1234 5678", en: "+31 6 1234 5678" },
    company: { nl: "Bedrijf (optioneel)", en: "Company (optional)" },
    companyPlaceholder: { nl: "Je bedrijfsnaam", en: "Your company name" },
    message: { nl: "Vertel ons over je project", en: "Tell us about your project" },
    messagePlaceholder: { nl: "Ik ben geïnteresseerd in...", en: "I'm interested in..." },
    address: { nl: "Je adres (optioneel)", en: "Your address (optional)" },
    addressPlaceholder: { nl: "Je adres", en: "Your address" },
    submit: { nl: "Verstuur bericht", en: "Send message" },
    sending: { nl: "Verzenden...", en: "Sending..." },
    success: {
      nl: "Bericht verzonden! We nemen snel contact met je op.",
      en: "Message sent! We'll get back to you soon.",
    },
    error: {
      nl: "Er ging iets mis. Probeer het opnieuw of mail ons direct.",
      en: "Something went wrong. Please try again or email us directly.",
    },
  },
}

export function socialLinks() {
  return [
    { label: "LinkedIn", url: company.socialProfiles.linkedin, color: "#0A66C2", hoverColor: "#004182" },
    { label: "Instagram", url: company.socialProfiles.instagram, color: "#E4405F", hoverColor: "#D62976" },
    { label: "Facebook", url: company.socialProfiles.facebook, color: "#1877F2", hoverColor: "#0E58BD" },
  ]
}
